if (!customElements.get('geosort-story-funnels')) {
  customElements.define('geosort-story-funnels', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.buttons = [...this.querySelectorAll('button[data-funnel-view]')];
      this.rows = [...this.querySelectorAll('.gsc-funnel-columns')].map(row => [...row.querySelectorAll('[data-funnel-step]')]);
      this.buttons.forEach(button => button.addEventListener('click', () => this.select(button.dataset.funnelView), { signal: this.controller.signal }));
      this.select(this.dataset.funnelView || 'full');
    }
    select(view) {
      const purchase = view === 'purchase';
      // Both charts share a denominator, including when zooming into purchase stages.
      const scale = purchase ? Math.max(1, ...this.rows.flatMap(row => row.slice(1).map(step => Number(step.dataset.rate)))) : 100;
      this.dataset.funnelView = view;
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.funnelView === view)));
      this.rows.forEach(row => row.forEach((step, index) => {
        step.hidden = purchase && index === 0;
        const top = Math.max(0, 100 - Number(step.dataset.rate) / scale * 100);
        const nextTop = Math.max(0, 100 - Number(step.dataset.nextRate) / scale * 100);
        step.querySelector('.gsc-funnel-area').style.clipPath = `polygon(0% 100%,0% ${top}%,72% ${top}%,100% ${nextTop}%,100% 100%)`;
        const baseline = step.querySelector('.gsc-funnel-area--baseline');
        if (baseline) {
          const baselineTop = Math.max(0, 100 - Number(step.dataset.baselineRate) / scale * 100);
          const nextBaselineTop = Math.max(0, 100 - Number(step.dataset.nextBaselineRate) / scale * 100);
          baseline.style.clipPath = `polygon(0% 100%,0% ${baselineTop}%,72% ${baselineTop}%,100% ${nextBaselineTop}%,100% 100%)`;
        }
      }));
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
if (!customElements.get('geosort-story-podcast')) {
  customElements.define('geosort-story-podcast', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.querySelector('[data-podcast-play]')?.addEventListener('click', () => {
        const content = this.querySelector('template').content.cloneNode(true);
        this.replaceChildren(content);
        this.querySelector('iframe')?.focus();
      }, { once: true, signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
